export default {"src":"/_next/static/media/settings-04.f3619592.svg","height":24,"width":25};